var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReward2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.87073 0H27.2506V2.03644H7.87073V0Z",
    fill: "#155934"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.95459 32.9642H26.1675V35H8.95459V32.9642Z",
    fill: "#155934"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.1003 4.61699L31.0512 4.1094H27.2509V3.52735C27.2509 3.4532 27.2422 3.38163 27.2396 3.30804H7.8826C7.88145 3.38134 7.87139 3.4532 7.87139 3.52735V4.10968H4.07128L4.02213 4.61728C4.01063 4.73713 4 4.85756 4 4.97944V10.016C4 12.4896 6.45725 14.5016 9.47695 14.5016H9.73564C11.2294 16.5447 13.5026 17.9809 16.1188 18.3712V21.2469H11.3122L10.4882 31.8228H24.6356L23.8116 21.2469H19.0044V18.3712C21.62 17.9809 23.8935 16.5441 25.387 14.5016H25.6462C28.6665 14.5016 31.1237 12.4896 31.1237 10.016V4.97944C31.1237 4.85728 31.1134 4.73713 31.101 4.61699H31.1003ZM8.91556 13.3504C6.77942 13.1368 5.12384 11.7233 5.12384 10.0159V5.23287H7.87137V8.78861C7.87137 10.3631 8.24933 11.848 8.91556 13.1627V13.3504ZM30.0003 10.0162C30.0003 11.7233 28.3438 13.1377 26.2083 13.3507V13.1632C26.8745 11.8489 27.252 10.3634 27.252 8.78891V5.23317H30.0004L30.0003 10.0162Z",
    fill: "#155934"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReward2);
export default __webpack_public_path__ + "static/media/reward2.c8ca4455.svg";
export { ForwardRef as ReactComponent };